import { render, staticRenderFns } from "./SimplePaginator.vue?vue&type=template&id=31598b57&scoped=true"
import script from "./SimplePaginator.vue?vue&type=script&lang=js"
export * from "./SimplePaginator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31598b57",
  null
  
)

export default component.exports